__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-events-explorer/v1_3_6/";